@if (actionsDamage) {
  <div class="actions-accordion">
    <app-smartphoto-damage-actions [damage]="actionsDamage"></app-smartphoto-damage-actions>
  </div>
} @else {
  <app-footer selectorForPadding=".smartphoto-detail">
    @if (secondaryActionsIsActive$ | async) {
      <div class="actions-accordion">
        <app-upward-accordion [hasHeader]="false" (onClose)="closeSecondaryActions()">
          <div content-header class="actions-accordion__header">{{ 'actions.damage_estimation_actions' | i18nextEager }}</div>
          <div class="actions-accordion__content">
            @if (smartphotoService.abilities.canSendPdfReport$ | async) {
              <div class="actions-accordion__content-item">
                <bdeo-link
                  size="medium"
                  target="_blank"
                  color="var(--default)"
                  icon="action-send-outline"
                  (click)="openSendReportDrawer()"
                  >{{ 'actions.send_report' | i18nextEager }}</bdeo-link
                >
              </div>
            }
            <div class="actions-accordion__content-item">
              <bdeo-link data-test-id="actions-logout" size="medium" icon="action-off" (click)="openLogOutDialog()">{{
                'login.logout_title' | i18nextEager
              }}</bdeo-link>
            </div>
          </div>
        </app-upward-accordion>
      </div>
    } @else {
      @if (smartphotoService.abilities.showEstimation$ | async) {
        <app-upward-accordion>
          <div header class="footer__accordion-header">
            <span class="total-label">{{ 'estimation.summary_total_estimation' | i18nextEager }}</span>
            <span class="total-value"
              >{{ smartphoto?.estimation?.total?.value ?? 0 | number: '1.2-2'
              }}<span class="currency">{{ smartphoto?.estimationConfig?.currency ?? '€' }}</span></span
            >
          </div>
          <div content-header class="footer__accordion-content-header">{{ 'estimation.summary_global_breakdown' | i18nextEager }}</div>
          <div class="footer__accordion-content-body">
            <div class="footer__accordion-content-body__item">
              <span class="footer__accordion-content-body__item-label">{{ 'estimation.summary_total_pieces' | i18nextEager }}</span>
              <span class="footer__accordion-content-body__item-value"
                >{{ smartphoto?.estimation?.total?.pieces ?? 0 | number: '1.2-2'
                }}<span class="currency">{{ smartphoto?.estimationConfig?.currency ?? '€' }}</span></span
              >
            </div>
            <div class="footer__accordion-content-body__item">
              <span class="footer__accordion-content-body__item-label">{{ 'estimation.summary_total_paint' | i18nextEager }}</span>
              <span class="footer__accordion-content-body__item-value"
                >{{ smartphoto?.estimation?.total?.paint?.total ?? 0 | number: '1.2-2'
                }}<span class="currency">{{ smartphoto?.estimationConfig?.currency ?? '€' }}</span></span
              >
            </div>
            <div class="footer__accordion-content-body__item">
              <span class="footer__accordion-content-body__item-label">{{ 'estimation.summary_total_labour' | i18nextEager }}</span>
              <span class="footer__accordion-content-body__item-value"
                >{{ smartphoto?.estimation?.total?.labour?.total ?? 0 | number: '1.2-2'
                }}<span class="currency">{{ smartphoto?.estimationConfig?.currency ?? '€' }}</span></span
              >
            </div>
            <bdeo-divider></bdeo-divider>
            <div class="footer__accordion-content-body__item">
              <span class="footer__accordion-content-body__item-label">{{ 'estimation.summary_tax_base' | i18nextEager }}</span>
              <span class="footer__accordion-content-body__item-value"
                >{{ smartphoto?.estimation?.total?.tax?.base ?? 0 | number: '1.2-2'
                }}<span class="currency">{{ smartphoto?.estimationConfig?.currency ?? '€' }}</span></span
              >
            </div>
            <div class="footer__accordion-content-body__item">
              <span class="footer__accordion-content-body__item-label"
                >{{ 'estimation.summary_tax_name' | i18nextEager }}
                {{ smartphoto?.estimationConfig?.taxPercentage ?? 0 | number: '1.2-2' }}%</span
              >
              <span class="footer__accordion-content-body__item-value"
                >{{ smartphoto?.estimation?.total?.tax?.cost ?? 0 | number: '1.2-2'
                }}<span class="currency">{{ smartphoto?.estimationConfig?.currency ?? '€' }}</span></span
              >
            </div>
            <bdeo-divider></bdeo-divider>
          </div>
        </app-upward-accordion>
      }
      @if (!transactionService.empty) {
        <bdeo-button
          data-test-id="transaction-accept"
          size="medium"
          type="primary"
          skin=""
          text="{{ 'actions.transaction_accept' | i18nextEager }}"
          [icon]="transactionService.executing ? 'loading-circle' : 'check-check'"
          [disabled]="transactionService.executing"
          iconposition="left"
          htmltype="button"
          (click)="transactionService.execute()"
        ></bdeo-button>
        <bdeo-button
          data-test-id="transaction-reject"
          size="medium"
          type="secondary"
          skin="ghost"
          text="{{ 'actions.transaction_reject' | i18nextEager }}"
          [disabled]="transactionService.executing"
          htmltype="button"
          (click)="cancelTransaction()"
        ></bdeo-button>
      } @else {
        @if (smartphotoService.abilities.canReview$ | async) {
          <bdeo-button
            data-test-id="review-smartphoto"
            size="medium"
            type="primary"
            skin=""
            text="{{ 'actions.review_smartphoto' | i18nextEager }}"
            icon="check-check"
            iconposition="left"
            htmltype="button"
            (click)="reviewSmartphoto()"
          ></bdeo-button>
        }
        @if ((smartphotoService.abilities.canDownloadPdfReport$ | async) && !(galleryIsActive$ | async)) {
          <bdeo-button
            data-test-id="download-pdf-report"
            size="medium"
            type="primary"
            skin=""
            text="{{ 'actions.download_report' | i18nextEager }}"
            icon="arrow-download-outline"
            iconposition="left"
            htmltype="button"
            (click)="downloadReport()"
          ></bdeo-button>
        }
        @if (smartphotoService.abilities.canTakePictures$ | async) {
          <bdeo-button
            data-test-id="take-pictures"
            size="medium"
            type="primary"
            skin=""
            text="{{ 'actions.take_pictures' | i18nextEager }}"
            icon="media-camera-outline"
            iconposition="left"
            htmltype="button"
            (click)="goToEvidenceCapture()"
          ></bdeo-button>
        }
        @if (smartphotoService.abilities.showAdditionalsButton$ | async) {
          <bdeo-button
            data-test-id="go-to-additionals"
            size="medium"
            type="primary"
            skin=""
            text="{{ 'actions.edit_damages' | i18nextEager }}"
            icon="action-send-outline"
            iconposition="left"
            htmltype="button"
            (click)="goToAdditionals()"
          ></bdeo-button>
        }
        @if (images$ | async; as images) {
          @if ((galleryIsActive$ | async) && (smartphotoService.abilities.showDownloadImagesButton$ | async) && images.length) {
            <bdeo-button
              data-test-id="download-zip-images"
              size="medium"
              type="primary"
              text="{{ 'actions.download_images' | i18nextEager }}"
              icon="arrow-download-outline"
              iconposition="left"
              htmltype="button"
              (click)="downloadImages()"
            ></bdeo-button>
          }
        }
      }
    }
  </app-footer>
}
<app-smartphoto-report-send-drawer></app-smartphoto-report-send-drawer>
<app-smartphoto-review-drawer [smartphoto]="smartphoto" [company]="company"></app-smartphoto-review-drawer>
